export const statuses = [
  { value: 0, name: "In Planning" },
  { value: 1, name: "Final" },
  { value: 2, name: "In Progress" },
  { value: 3, name: "Done" },
];
